<template>
  <header class="headerMain">
    <div class="headerMain--container">
      <NavBar/>
    </div>
  </header>
</template>

<script>
import NavBar from '@/components/_NavBar'

export default {
  name: 'HeaderMain',
  components: {
    NavBar
  },
  methods: {
    classNav () {
      let body2 = document.body
      body2.classList.add('scrollTop')
      window.onscroll = function changeClass () {
        let scrollPosY = window.pageYOffset | document.body.scrollTop
        let body = document.body
        if (scrollPosY > 50) {
          body.className = ('scrollNav')
        } else if (scrollPosY <= 50) {
          body.className = ('scrollTop')
        }
      }
    }
  },
  created () {
    this.classNav()
  }
}
</script>

<style>

</style>
